"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const dnaR_dropdown_multiSelect_model_1 = require("./dnaR-dropdown-multiSelect.model");
const i0 = require("@angular/core");
const i1 = require("./dnaR-dropdown-multiSelect-click-outside.directive");
const i2 = require("@angular/common");
const i3 = require("../dnaR-spinner/dnaR-spinner.component");
const i4 = require("@angular/forms");
const i5 = require("./dnaR-dropdown-multiSelect-list-filter.pipe");
function DnaRDropdownMultiSelect_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵelement(1, "dnaR-spinner", 14);
    i0.ɵɵelementEnd();
} }
function DnaRDropdownMultiSelect_span_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r9.placeholder);
} }
function DnaRDropdownMultiSelect_span_4_span_2_span_1_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 22);
    i0.ɵɵlistener("click", function DnaRDropdownMultiSelect_span_4_span_2_span_1_a_2_Template_a_click_0_listener($event) { i0.ɵɵrestoreView(_r17); const item_r13 = i0.ɵɵnextContext().$implicit; const ctx_r16 = i0.ɵɵnextContext(3); $event.stopPropagation(); return ctx_r16.onItemClick(item_r13); });
    i0.ɵɵtext(1, "x");
    i0.ɵɵelementEnd();
} }
function DnaRDropdownMultiSelect_span_4_span_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, DnaRDropdownMultiSelect_span_4_span_2_span_1_a_2_Template, 2, 0, "a", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r13 = ctx.$implicit;
    const k_r14 = ctx.index;
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r12.settings.showSelectedItemsAsTabs ? "selected-item" : "selected-item-notab")("hidden", k_r14 > ctx_r12.settings.itemsShowLimit - 1);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r13.text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.settings.showSelectedItemsAsTabs);
} }
function DnaRDropdownMultiSelect_span_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, DnaRDropdownMultiSelect_span_4_span_2_span_1_Template, 3, 4, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r10.selectedItems)("ngForTrackBy", ctx_r10.trackByFn);
} }
function DnaRDropdownMultiSelect_span_4_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.selectedItems.length, " Selected ");
} }
function DnaRDropdownMultiSelect_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtemplate(1, DnaRDropdownMultiSelect_span_4_span_1_Template, 2, 1, "span", 16);
    i0.ɵɵtemplate(2, DnaRDropdownMultiSelect_span_4_span_2_Template, 2, 2, "span", 12);
    i0.ɵɵtemplate(3, DnaRDropdownMultiSelect_span_4_span_3_Template, 2, 1, "span", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedItems.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedItems.length > 0 && ctx_r1.settings.itemsShowLimit >= ctx_r1.selectedItems.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedItems.length > ctx_r1.settings.itemsShowLimit);
} }
function DnaRDropdownMultiSelect_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelementStart(2, "a", 25);
    i0.ɵɵlistener("click", function DnaRDropdownMultiSelect_span_5_Template_a_click_2_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); $event.stopPropagation(); return ctx_r19.onClearSelectedItems(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DnaRDropdownMultiSelect_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 26);
    i0.ɵɵlistener("click", function DnaRDropdownMultiSelect_li_10_Template_li_click_0_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); $event.stopPropagation(); return ctx_r21.toggleSelectAll(); });
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(!ctx_r3.isAllItemsSelected() ? ctx_r3.settings.selectAllText : ctx_r3.settings.unSelectAllText);
} }
function DnaRDropdownMultiSelect_li_11_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 30);
    i0.ɵɵlistener("ngModelChange", function DnaRDropdownMultiSelect_li_11_input_2_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.filter.text = $event; })("ngModelChange", function DnaRDropdownMultiSelect_li_11_input_2_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.onFilterTextChange($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("readOnly", ctx_r23.disabled)("placeholder", ctx_r23.settings.searchPlaceholderText)("ngModel", ctx_r23.filter.text);
} }
function DnaRDropdownMultiSelect_li_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 27);
    i0.ɵɵelement(1, "span", 28);
    i0.ɵɵtemplate(2, DnaRDropdownMultiSelect_li_11_input_2_Template, 1, 3, "input", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r4.settings.singleSelection);
} }
const _c0 = function (a0) { return { "li-disabled": a0 }; };
function DnaRDropdownMultiSelect_li_13_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 31);
    i0.ɵɵlistener("click", function DnaRDropdownMultiSelect_li_13_Template_li_click_0_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(); $event.stopPropagation(); return ctx_r27.onAllOptionChange(); });
    i0.ɵɵelementStart(1, "input", 32);
    i0.ɵɵlistener("ngModelChange", function DnaRDropdownMultiSelect_li_13_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.allOptionSelected = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx_r5.selectedItems.length === 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r5.allOptionSelected)("disabled", ctx_r5.disabled || ctx_r5.selectedItems.length === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r5.settings.selectAllText);
} }
function DnaRDropdownMultiSelect_li_14_input_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 37);
} if (rf & 2) {
    const item_r30 = i0.ɵɵnextContext().$implicit;
    const ctx_r33 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r33.isSelected(item_r30))("disabled", ctx_r33.disabled || ctx_r33.isLimitSelectionReached() && !ctx_r33.isSelected(item_r30));
} }
const _c1 = function (a0, a1, a2) { return { "multiselect-item-checkbox": a0, "item-header": a1, "is-selected-item": a2 }; };
function DnaRDropdownMultiSelect_li_14_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 33, 34);
    i0.ɵɵlistener("click", function DnaRDropdownMultiSelect_li_14_Template_li_click_0_listener($event) { i0.ɵɵrestoreView(_r36); const item_r30 = ctx.$implicit; const ctx_r35 = i0.ɵɵnextContext(); $event.stopPropagation(); return ctx_r35.onItemClick(item_r30); });
    i0.ɵɵtemplate(2, DnaRDropdownMultiSelect_li_14_input_2_Template, 1, 2, "input", 35);
    i0.ɵɵelementStart(3, "div", 36);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r30 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "item-", item_r30.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c1, !item_r30.isHeader, item_r30.isHeader, ctx_r6.isSelected(item_r30, true)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !item_r30.isHeader && !ctx_r6.settings.singleSelection);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r30.text);
} }
function DnaRDropdownMultiSelect_li_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.settings.noSearchResultFoundPlaceholderText);
} }
function DnaRDropdownMultiSelect_li_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r8.settings.noDataAvailablePlaceholderText);
} }
exports.DROPDOWN_CONTROL_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(() => DnaRDropdownMultiSelect),
    multi: true
};
const noop = () => { };
class DnaRDropdownMultiSelect {
    constructor(elRef) {
        this.elRef = elRef;
        this.selectedItems = [];
        this.isDropdownOpen = true;
        this.allOptionSelected = true;
        this._placeholder = 'Select';
        this._data = null;
        this._currentDataHeaders = [];
        this._defaultSettings = {
            singleSelection: false,
            headerField: 'header',
            idField: 'id',
            textField: 'text',
            addAllOption: true,
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: false,
            limitSelection: -1,
            clearSearchFilter: true,
            maxHeight: 197,
            itemsShowLimit: 999999999999,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No data available',
            noSearchResultFoundPlaceholderText: 'No search result found',
            closeDropDownOnSelection: false,
            defaultOpen: false,
            showSelectedItemsAsTabs: false,
            selectedItemsAsCommaSeparated: false,
            showClearSelectedItems: true,
            scrollToSelection: false,
            scrollBehaviour: 'auto',
            scrollPosition: 'start'
        };
        this.currentControlName = null;
        this.currentError = null;
        this.disabled = false;
        /**
         * Event emitted when the selected options have been changed by the user.
         */
        this.initialSelectedItemsChange = new core_1.EventEmitter();
        this.onFilterChange = new core_1.EventEmitter();
        this.onDropDownClose = new core_1.EventEmitter();
        this.onSelect = new core_1.EventEmitter();
        this.onDeSelect = new core_1.EventEmitter();
        this.onSelectAll = new core_1.EventEmitter();
        this.onDeSelectAll = new core_1.EventEmitter();
        this.onTouchedEvent = new core_1.EventEmitter();
        this.onSelectionChange = new core_1.EventEmitter();
        this.onInitialised = new core_1.EventEmitter();
        this.onComponentChange = new core_1.EventEmitter();
        this.onTouchedCallback = () => { this.onTouchedEvent.emit(true); };
        this.onChangeCallback = noop;
        this._settings = Object.assign(this._defaultSettings);
    }
    set formControlName(value) {
        if (value != null) {
            this.currentControlName = value;
        }
    }
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(value) {
        if (value != null) {
            this._placeholder = value;
        }
        else {
            this._placeholder = 'Select';
        }
    }
    set selectedItemsAsCommaSeparated(value) {
        if (value != null) {
            this._defaultSettings.selectedItemsAsCommaSeparated = value;
        }
    }
    set enableCheckAll(value) {
        if (value != null) {
            this._defaultSettings.enableCheckAll = value;
        }
    }
    set allowSearchFilter(value) {
        if (value != null) {
            this._defaultSettings.allowSearchFilter = value;
        }
    }
    set showSelectedItemsAsTabs(value) {
        if (value != null) {
            this._defaultSettings.showSelectedItemsAsTabs = value;
        }
    }
    set searchPlaceholderText(value) {
        if (value != null) {
            this._defaultSettings.searchPlaceholderText = value;
        }
    }
    set noDataAvailablePlaceholderText(value) {
        if (value != null) {
            this._defaultSettings.noDataAvailablePlaceholderText = value;
        }
    }
    set noSearchResultFoundPlaceholderText(value) {
        if (value != null) {
            this._defaultSettings.noSearchResultFoundPlaceholderText = value;
        }
    }
    get settings() {
        return this._settings;
    }
    set settings(value) {
        if (value) {
            this._settings = Object.assign(this._defaultSettings, value);
        }
        else {
            this._settings = Object.assign(this._defaultSettings);
        }
    }
    setData(values) {
        this._data = [];
        this._currentDataHeaders = [];
        values.forEach(value => {
            if (typeof value === 'string') {
                this._data.push(new dnaR_dropdown_multiSelect_model_1.ListItem(value));
            }
            else {
                if (this.itemHasNewHeader(value[this._settings.headerField])) {
                    this._data.push(new dnaR_dropdown_multiSelect_model_1.ListItem({
                        isHeader: true,
                        id: 0,
                        text: value[this._settings.headerField]
                    }));
                }
                this._data.push(new dnaR_dropdown_multiSelect_model_1.ListItem({
                    isHeader: false,
                    id: value[this._settings.idField],
                    text: value[this._settings.textField]
                }));
            }
        });
    }
    getData() {
        return this._data;
    }
    setInitialSelectedItems(values) {
        values.forEach(x => {
            var item = this._data.find(i => Number(i.id) == Number(x));
            const found = this.isSelected(item);
            const allowAdd = this._settings.limitSelection === -1 ||
                (this._settings.limitSelection > 0 &&
                    this.selectedItems.length < this._settings.limitSelection);
            if (item && !found && allowAdd) {
                this.addSelected(item, false);
            }
        });
    }
    ngOnChanges() {
        if (this.data !== undefined && this.data !== null) {
            this.setData(this.data);
            this.filter = new dnaR_dropdown_multiSelect_model_1.ListItem(this.data);
            if (this.initialSelectedItems !== undefined && this.initialSelectedItems !== null) {
                this.setInitialSelectedItems(this.initialSelectedItems);
            }
        }
    }
    ngOnInit() {
        if (this.selectedItems.length > 0) {
            this.emitInitialisedEvent();
        }
    }
    ngAfterViewChecked() {
        this.scrollToSelectedItem();
    }
    onFilterTextChange($event) {
        this.onFilterChange.emit($event);
    }
    onItemClick(item) {
        if (this.disabled) {
            return false;
        }
        this.onTouchedCallback();
        const found = this.isSelected(item);
        const allowAdd = this._settings.limitSelection === -1 ||
            (this._settings.limitSelection > 0 &&
                this.selectedItems.length < this._settings.limitSelection);
        if (!found) {
            if (allowAdd) {
                this.addSelected(item, true);
            }
        }
        else {
            if (!this._settings.singleSelection) {
                this.removeSelected(item);
            }
        }
        if (this._settings.singleSelection || this._settings.closeDropDownOnSelection) {
            this.closeDropdown();
        }
    }
    onClearSelectedItems() {
        if (this.disabled) {
            return false;
        }
        this.onTouchedCallback();
        this.selectedItems = [];
        if (this._settings.singleSelection || this._settings.closeDropDownOnSelection) {
            this.closeDropdown();
        }
        this.onChangeCallback(this.emittedValue(this.selectedItems));
        this.onDeSelectAll.emit(this.emittedValue(this.selectedItems));
        this.onSelectionChange.emit(this.selectedItems);
        this.initialSelectedItemsChange.emit(this.selectedItems.map((i, n) => Number(i.id)));
        this.emitComponentChangeEvent();
    }
    writeValue(value) {
        /* For some reason writeValue gets executed before inputs were evaluated.
        Therefore, inputed settings were not present when this method was called.
        Angular say that this is working as intended and a work around is to use setTimeout which basically delays it a bit.
        This is was found when one option was selected already but no text/name displayed in the component.. it was null.
        This problem is present when textField is changed.
        */
        setTimeout(() => {
            if (value !== undefined && value !== null && value.length > 0) {
                if (this._settings.singleSelection) {
                    try {
                        if (value.length >= 1) {
                            const firstItem = value[0];
                            this.selectedItems = [
                                typeof firstItem === 'string'
                                    ? new dnaR_dropdown_multiSelect_model_1.ListItem(firstItem)
                                    : new dnaR_dropdown_multiSelect_model_1.ListItem({
                                        id: firstItem[this._settings.idField],
                                        text: firstItem[this._settings.textField]
                                    })
                            ];
                        }
                    }
                    catch (e) {
                        // console.error(e.body.msg);
                    }
                }
                else {
                    if (typeof value === 'string') {
                        value = value.split(',');
                    }
                    const _data = value.map((item) => typeof item === 'string'
                        ? new dnaR_dropdown_multiSelect_model_1.ListItem(item)
                        : new dnaR_dropdown_multiSelect_model_1.ListItem({
                            id: item[this._settings.idField],
                            text: item[this._settings.textField]
                        }));
                    if (this._settings.limitSelection > 0) {
                        this.selectedItems = _data.splice(0, this._settings.limitSelection);
                    }
                    else {
                        this.selectedItems = _data;
                    }
                }
            }
            else if (value !== undefined && value !== null && (!this._settings.singleSelection && (value.length === undefined || value.length === 0))) {
                this.selectedItems = [];
            }
            if (value != null && value instanceof Array && this._defaultSettings.selectedItemsAsCommaSeparated) {
                value = value.join(',');
            }
        });
    }
    itemHasNewHeader(header) {
        if (header !== undefined &&
            header !== null &&
            header !== '' &&
            this._currentDataHeaders.indexOf(header) < 0) {
            this._currentDataHeaders.push(header);
            return true;
        }
        return false;
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    onTouched() {
        this.closeDropdown();
        this.onTouchedCallback();
    }
    trackByFn(index, item) {
        return item.id;
    }
    isSelected(clickedItem) {
        let found = false;
        this.selectedItems.forEach(item => {
            if (item !== undefined && clickedItem !== undefined && clickedItem.id === item.id) {
                found = true;
            }
        });
        return found;
    }
    isLimitSelectionReached() {
        const limitSelectionReached = this._settings.limitSelection === this.selectedItems.length;
        return limitSelectionReached;
    }
    isAllItemsSelected() {
        const allItemsSelected = this._data.length === this.selectedItems.length;
        return allItemsSelected;
    }
    showButton() {
        if (!this._settings.singleSelection) {
            if (this._settings.limitSelection > 0) {
                return false;
            }
            return true;
        }
        else {
            return false;
        }
    }
    itemShowRemaining() {
        return this.selectedItems.length - this._settings.itemsShowLimit;
    }
    addSelected(item, notify = false) {
        if (this._settings.singleSelection) {
            this.selectedItems = [];
            this.selectedItems.push(item);
        }
        else {
            this.selectedItems.push(item);
        }
        this.allOptionSelected = false;
        if (notify) {
            this.onChangeCallback(this.emittedValue(this.selectedItems));
            this.onSelect.emit(this.emittedValue(item));
            this.onSelectionChange.emit(this.selectedItems);
            this.initialSelectedItemsChange.emit(this.selectedItems.map((i, n) => Number(i.id)));
            this.emitComponentChangeEvent();
        }
    }
    removeSelected(itemSel) {
        this.selectedItems.forEach(item => {
            if (itemSel.id === item.id) {
                this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
            }
        });
        if (this.selectedItems.length === 0) {
            this.allOptionSelected = true;
        }
        this.onChangeCallback(this.emittedValue(this.selectedItems));
        this.onDeSelect.emit(this.emittedValue(itemSel));
        this.onSelectionChange.emit(this.selectedItems);
        this.initialSelectedItemsChange.emit(this.selectedItems.map((i, n) => Number(i.id)));
        this.emitComponentChangeEvent();
    }
    emittedValue(val) {
        const selected = [];
        if (Array.isArray(val)) {
            val.map(item => {
                if (item.id === item.text) {
                    selected.push(item.text);
                }
                else {
                    selected.push(this.objectify(item));
                }
            });
        }
        else {
            if (val) {
                if (val.id === val.text) {
                    return val.text;
                }
                else {
                    return this.objectify(val);
                }
            }
        }
        if (this._defaultSettings.selectedItemsAsCommaSeparated) {
            return selected.join(',');
        }
        return selected;
    }
    objectify(val) {
        const obj = {};
        obj[this._settings.idField] = val.id;
        obj[this._settings.textField] = val.text;
        return obj;
    }
    toggleDropdown(evt) {
        evt.preventDefault();
        if (this.disabled) {
            return;
        }
        // Disable drop down if there is no data and the spinner is visible
        if (this.getData() === null) {
            return;
        }
        this._settings.defaultOpen = !this._settings.defaultOpen;
        if (!this._settings.defaultOpen) {
            this.onTouchedCallback();
            this.onDropDownClose.emit();
        }
    }
    closeDropdown() {
        if (this._settings.defaultOpen) {
            this.onTouchedCallback();
        }
        this._settings.defaultOpen = false;
        if (this._settings.clearSearchFilter) {
            if (this.filter) {
                this.filter.text = '';
            }
        }
        this.onDropDownClose.emit();
    }
    toggleSelectAll() {
        if (this.disabled) {
            return false;
        }
        if (!this.isAllItemsSelected()) {
            this.selectedItems = this._data.slice();
            this.onSelectAll.emit(this.emittedValue(this.selectedItems));
            this.onSelectionChange.emit(this.selectedItems);
            this.emitComponentChangeEvent();
        }
        else {
            this.selectedItems = [];
            this.onDeSelectAll.emit(this.emittedValue(this.selectedItems));
            this.onSelectionChange.emit(this.selectedItems);
            this.emitComponentChangeEvent();
        }
        this.initialSelectedItemsChange.emit(this.selectedItems.map((i, n) => Number(i.id)));
        this.onChangeCallback(this.emittedValue(this.selectedItems));
    }
    onAllOptionChange() {
        this.allOptionSelected = true;
        this.selectedItems = [];
        this.onDeSelectAll.emit(this.emittedValue(this.selectedItems));
        this.onSelectionChange.emit(this.selectedItems);
        this.initialSelectedItemsChange.emit(this.selectedItems.map((i, n) => Number(i.id)));
        this.emitComponentChangeEvent();
        this.onChangeCallback(this.emittedValue(this.selectedItems));
    }
    /*
        Only scroll when :
        setting.scrollToSelection = true
        settings.singleSelection = true
    */
    scrollToSelectedItem() {
        if (this._settings.scrollToSelection && this._settings.singleSelection) {
            let selectedItemId = this.selectedItems[0].id;
            let selectedListItem = this.elRef.nativeElement.querySelector('#item-' + selectedItemId);
            if (selectedListItem) {
                selectedListItem.scrollIntoView({ behavior: this._settings.scrollBehaviour, block: this._settings.scrollPosition });
            }
        }
    }
    emitInitialisedEvent() {
        var EventEmitterValue = { controlName: this.currentControlName, value: this.selectedItems, isInValid: false, error: null };
        this.onInitialised.emit(EventEmitterValue);
    }
    emitComponentChangeEvent() {
        var EventEmitterValue = (this.currentError !== null && this.currentError !== undefined)
            ? { controlName: this.currentControlName, value: this.selectedItems, isInValid: true, error: this.currentError }
            : { controlName: this.currentControlName, value: this.selectedItems, isInValid: false, error: null };
        this.onComponentChange.emit(EventEmitterValue);
    }
}
exports.DnaRDropdownMultiSelect = DnaRDropdownMultiSelect;
DnaRDropdownMultiSelect.ɵfac = function DnaRDropdownMultiSelect_Factory(t) { return new (t || DnaRDropdownMultiSelect)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
DnaRDropdownMultiSelect.ɵcmp = i0.ɵɵdefineComponent({ type: DnaRDropdownMultiSelect, selectors: [["dnaR-dropdown-multiSelect"]], hostBindings: function DnaRDropdownMultiSelect_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("blur", function DnaRDropdownMultiSelect_blur_HostBindingHandler() { return ctx.onTouched(); });
    } }, inputs: { formControlName: "formControlName", error: "error", placeholder: "placeholder", disabled: "disabled", selectedItemsAsCommaSeparated: "selectedItemsAsCommaSeparated", enableCheckAll: "enableCheckAll", allowSearchFilter: "allowSearchFilter", showSelectedItemsAsTabs: "showSelectedItemsAsTabs", searchPlaceholderText: "searchPlaceholderText", noDataAvailablePlaceholderText: "noDataAvailablePlaceholderText", noSearchResultFoundPlaceholderText: "noSearchResultFoundPlaceholderText", settings: "settings", data: "data", initialSelectedItems: "initialSelectedItems" }, outputs: { initialSelectedItemsChange: "initialSelectedItemsChange", onFilterChange: "onFilterChange", onDropDownClose: "onDropDownClose", onSelect: "onSelect", onDeSelect: "onDeSelect", onSelectAll: "onSelectAll", onDeSelectAll: "onDeSelectAll", onTouchedEvent: "onTouchedEvent", onSelectionChange: "onSelectionChange", onInitialised: "onInitialised", onComponentChange: "onComponentChange" }, features: [i0.ɵɵProvidersFeature([exports.DROPDOWN_CONTROL_VALUE_ACCESSOR]), i0.ɵɵNgOnChangesFeature], decls: 19, vars: 22, consts: [["tabindex", "=0", 1, "multiselect-dropdown", 3, "blur", "clickOutside"], ["tabindex", "-1", 1, "dnaRComponent", "dropdown-btn", 3, "ngClass", "click"], ["class", "spinner", 4, "ngIf"], ["class", "seletedItems", 4, "ngIf"], ["class", "selected-items-clear", 4, "ngIf"], [1, "toggle-arrow"], [3, "ngClass"], [1, "dropdown-list", 3, "hidden"], ["class", "multiselect-item-checkbox selectAllsection", 3, "click", 4, "ngIf"], ["class", "filter-textbox", 4, "ngIf"], ["class", "multiselect-item-checkbox", 3, "ngClass", "click", 4, "ngIf"], [3, "id", "ngClass", "click", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "spinner"], ["data-automation", "spinner"], [1, "seletedItems"], ["class", "placeholder", 4, "ngIf"], ["class", "selected-item-notab", 4, "ngIf"], [1, "placeholder"], [3, "ngClass", "hidden", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "ngClass", "hidden"], ["class", "selected-item-remove", 3, "click", 4, "ngIf"], [1, "selected-item-remove", 3, "click"], [1, "selected-item-notab"], [1, "selected-items-clear"], [3, "click"], [1, "multiselect-item-checkbox", "selectAllsection", 3, "click"], [1, "filter-textbox"], [1, "search-icon"], ["type", "text", "aria-label", "multiselect-search", 3, "readOnly", "placeholder", "ngModel", "ngModelChange", 4, "ngIf"], ["type", "text", "aria-label", "multiselect-search", 3, "readOnly", "placeholder", "ngModel", "ngModelChange"], [1, "multiselect-item-checkbox", 3, "ngClass", "click"], ["type", "checkbox", 3, "ngModel", "disabled", "ngModelChange"], [3, "id", "ngClass", "click"], ["item", ""], ["type", "checkbox", "aria-label", "multiselect-item", 3, "checked", "disabled", 4, "ngIf"], ["id", "itemText"], ["type", "checkbox", "aria-label", "multiselect-item", 3, "checked", "disabled"]], template: function DnaRDropdownMultiSelect_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("blur", function DnaRDropdownMultiSelect_Template_div_blur_0_listener() { return ctx.onTouched(); })("clickOutside", function DnaRDropdownMultiSelect_Template_div_clickOutside_0_listener() { return ctx.closeDropdown(); });
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵelementStart(2, "span", 1);
        i0.ɵɵlistener("click", function DnaRDropdownMultiSelect_Template_span_click_2_listener($event) { $event.stopPropagation(); return ctx.toggleDropdown($event); });
        i0.ɵɵtemplate(3, DnaRDropdownMultiSelect_span_3_Template, 2, 0, "span", 2);
        i0.ɵɵtemplate(4, DnaRDropdownMultiSelect_span_4_Template, 4, 3, "span", 3);
        i0.ɵɵtemplate(5, DnaRDropdownMultiSelect_span_5_Template, 3, 0, "span", 4);
        i0.ɵɵelementStart(6, "span", 5);
        i0.ɵɵelement(7, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "ul");
        i0.ɵɵtemplate(10, DnaRDropdownMultiSelect_li_10_Template, 3, 1, "li", 8);
        i0.ɵɵtemplate(11, DnaRDropdownMultiSelect_li_11_Template, 3, 1, "li", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "ul");
        i0.ɵɵtemplate(13, DnaRDropdownMultiSelect_li_13_Template, 4, 6, "li", 10);
        i0.ɵɵtemplate(14, DnaRDropdownMultiSelect_li_14_Template, 5, 8, "li", 11);
        i0.ɵɵpipe(15, "dnaRDropdownMultiSelectFilter");
        i0.ɵɵtemplate(16, DnaRDropdownMultiSelect_li_16_Template, 3, 1, "li", 12);
        i0.ɵɵpipe(17, "dnaRDropdownMultiSelectFilter");
        i0.ɵɵtemplate(18, DnaRDropdownMultiSelect_li_18_Template, 3, 1, "li", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("disabled", ctx.disabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.settings.defaultOpen ? "infocus" : "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.getData() === null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.getData() !== null && ctx.getData().length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.settings.showSelectedItemsAsTabs && ctx.selectedItems.length !== 0 && ctx.settings.showClearSelectedItems);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.settings.defaultOpen ? "dropdown-up" : "dropdown-down");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", !ctx.settings.defaultOpen);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.getData() !== null && ctx.getData().length > 0 && !ctx.settings.singleSelection && ctx.settings.enableCheckAll && ctx.settings.limitSelection === 0 - 1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.getData() !== null && ctx.getData().length > 0 && ctx.settings.allowSearchFilter);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("max-height", ctx.settings.maxHeight + "px");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.settings.addAllOption);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(15, 16, ctx.getData(), ctx.filter));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.getData() !== null && i0.ɵɵpipeBind2(17, 19, ctx.getData(), ctx.filter).length === 0 && ctx.filter.text != "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.getData() !== null && ctx.getData().length === 0);
    } }, directives: [i1.ClickOutsideDirective, i2.NgClass, i2.NgIf, i2.NgForOf, i3.DnaRSpinner, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i4.CheckboxControlValueAccessor], pipes: [i5.DnaRDropdownMultiSelectFilter], styles: [".dnaRComponent[_ngcontent-%COMP%] {\n  display: inline-block;\n  border: 1px solid #AAAAAA;\n  border-radius: 2px;\n  float: left;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0;\n}\n.dnaRComponent[_ngcontent-%COMP%]:hover {\n  border-color: #000000;\n}\n.dnaRComponent[_ngcontent-%COMP%]:focus-within {\n  border-color: #008381;\n}\n.valid[_ngcontent-%COMP%] {\n  border-color: #AAAAAA;\n}\n.invalid[_ngcontent-%COMP%] {\n  border-color: #C53535 !important;\n}\n.multiselect-dropdown[_ngcontent-%COMP%] {\n  position: relative;\n  width: 100%;\n  height: 34px;\n  font-size: 16px;\n  font-family: inherit;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%] {\n  display: flex;\n  border: 1px solid #AAAAAA;\n  width: 100%;\n  height: 34px;\n  margin-bottom: 0;\n  font-weight: normal;\n  line-height: 1.58857143;\n  text-align: left;\n  vertical-align: middle;\n  cursor: pointer;\n  background-image: none;\n  border-radius: 2px;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%] {\n  flex: 1;\n  height: 34px;\n  width: 34px;\n  padding: 5px 5px;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%] {\n  border: 1px solid #337ab7;\n  margin-right: 4px;\n  background: #337ab7;\n  padding: 0px 5px;\n  color: #fff;\n  border-radius: 2px;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] {\n  text-decoration: none;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item-notab[_ngcontent-%COMP%] {\n  border: 0;\n  margin-right: 4px;\n  background: #fff;\n  border-radius: 0;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item-notab[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] {\n  text-decoration: none;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-item-remove[_ngcontent-%COMP%] {\n  padding-top: 2px;\n  padding-left: 2px;\n  color: #fff;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-items-clear[_ngcontent-%COMP%] {\n  width: 27px;\n  padding-top: 6px;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selected-items-clear[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] {\n  display: inline-block;\n  padding-left: 5px;\n  line-height: 18px;\n  height: 19px;\n  width: 19px;\n  color: #fff;\n  border-radius: 50%;\n  text-decoration: none;\n  width: 20px;\n  height: 20px;\n  background-image: url(\"images/cancel-fill.svg\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .seletedItems[_ngcontent-%COMP%] {\n  flex: 1;\n  padding: 3px 6px;\n  display: inline-block;\n  height: 32px;\n  overflow: hidden;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .toggle-arrow[_ngcontent-%COMP%] {\n  padding-left: 11px;\n  border-left: 1px solid #D2D2D2;\n  width: 35px;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .dropdown-down[_ngcontent-%COMP%] {\n  display: inline-block;\n  position: relative;\n  top: 1px;\n  width: 0;\n  height: 0;\n  border-top: 6px solid #949494;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .dropdown-up[_ngcontent-%COMP%] {\n  display: inline-block;\n  position: relative;\n  top: 1px;\n  width: 0;\n  height: 0;\n  border-bottom: 6px solid #949494;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]   .selectAllsection[_ngcontent-%COMP%] {\n  border-bottom: 1px solid #ccc;\n  padding: 10px;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn[_ngcontent-%COMP%]:hover {\n  border-color: #000000;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .dropdown-btn.infocus[_ngcontent-%COMP%] {\n  border-color: #008381;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]    > span[_ngcontent-%COMP%] {\n  background-color: #eceeef;\n}\n.multiselect-dropdown[_ngcontent-%COMP%]   .placeholder[_ngcontent-%COMP%] {\n  color: #757575;\n}\n.dropdown-list[_ngcontent-%COMP%] {\n  position: absolute;\n  top: 34px;\n  padding: 4px 0;\n  width: 100%;\n  z-index: 9999;\n  border: 1px solid #ccc;\n  background: #fff;\n  box-shadow: 0px 1px 5px #959595;\n}\n.dropdown-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%] {\n  padding: 0px;\n  list-style: none;\n  overflow: auto;\n  margin: 0px;\n}\n.dropdown-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] {\n  padding: 8px 16px;\n  cursor: pointer;\n  text-align: left;\n  line-height: 24px;\n}\n.dropdown-list[_ngcontent-%COMP%]   .item-header[_ngcontent-%COMP%] {\n  font-weight: 600;\n}\n.dropdown-list[_ngcontent-%COMP%]   li.multiselect-item-checkbox[_ngcontent-%COMP%]:hover {\n  background: #008381;\n}\n.dropdown-list[_ngcontent-%COMP%]   li.multiselect-item-checkbox[_ngcontent-%COMP%]:hover   #itemText[_ngcontent-%COMP%] {\n  text-decoration: none;\n  color: white!important;\n}\n.dropdown-list[_ngcontent-%COMP%]   li.multiselect-item-checkbox[_ngcontent-%COMP%]:hover   input[type='checkbox'][_ngcontent-%COMP%]:checked    + div[_ngcontent-%COMP%]:before {\n  background-color: #fff;\n  border-color: #fff;\n}\n.dropdown-list[_ngcontent-%COMP%]   li.multiselect-item-checkbox[_ngcontent-%COMP%]:hover   input[type='checkbox'][_ngcontent-%COMP%]:checked    + div[_ngcontent-%COMP%]:after {\n  border-color: #008381;\n}\n.dropdown-list[_ngcontent-%COMP%]   .filter-textbox[_ngcontent-%COMP%] {\n  position: relative;\n  border: 1px solid #ccc;\n  padding: 5px;\n  margin: 5px 16px;\n  height: 34px;\n  border-radius: 2px;\n  cursor: default;\n}\n.dropdown-list[_ngcontent-%COMP%]   .filter-textbox[_ngcontent-%COMP%]   .search-icon[_ngcontent-%COMP%] {\n  float: left;\n  width: 20px;\n  height: 20px;\n  background-image: url(images/search-fill.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n  cursor: default;\n}\n.dropdown-list[_ngcontent-%COMP%]   .filter-textbox[_ngcontent-%COMP%]   input[_ngcontent-%COMP%] {\n  float: left;\n  border: 0px;\n  width: 80%;\n  padding: 0;\n  margin-left: 10px;\n  color: #757575;\n}\n.dropdown-list[_ngcontent-%COMP%]   .filter-textbox[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus {\n  outline: none;\n}\n.dropdown-list[_ngcontent-%COMP%]   .filter-textbox[_ngcontent-%COMP%]:hover {\n  border-color: #000;\n}\n.dropdown-list[_ngcontent-%COMP%]   .filter-textbox[_ngcontent-%COMP%]:has(input:focus) {\n  border-color: #008381;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%] {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:focus    + div[_ngcontent-%COMP%]:before, .multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:hover    + div[_ngcontent-%COMP%]:before {\n  border-color: #337ab7;\n  border: 2px;\n  background-color: #f2f2f2;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:active    + div[_ngcontent-%COMP%]:before {\n  transition-duration: 0s;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]    + div[_ngcontent-%COMP%] {\n  position: relative;\n  padding-left: 2em;\n  vertical-align: middle;\n  user-select: none;\n  cursor: pointer;\n  margin: 0px;\n  font-size: 16px;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]    + div[_ngcontent-%COMP%]:before {\n  box-sizing: content-box;\n  content: '';\n  color: #008381;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 14px;\n  height: 14px;\n  margin-top: -9px;\n  border: 2px solid #949494;\n  border-radius: 2px;\n  text-align: center;\n  transition: all 0.4s ease;\n  background-color: #fff;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]    + div[_ngcontent-%COMP%]:after {\n  box-sizing: content-box;\n  content: '';\n  background-color: #008381;\n  position: absolute;\n  left: 4px;\n  width: 9px;\n  height: 4px;\n  margin-top: -3px;\n  transform: scale(0);\n  transform-origin: 50%;\n  transition: transform 200ms ease-out;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:disabled    + div[_ngcontent-%COMP%]:before {\n  border-color: #cccccc;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:disabled:focus    + div[_ngcontent-%COMP%]:before   .multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:disabled:hover    + div[_ngcontent-%COMP%]:before {\n  background-color: inherit;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:disabled:checked    + div[_ngcontent-%COMP%]:before {\n  background-color: #cccccc;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]    + div[_ngcontent-%COMP%]:after {\n  background-color: transparent;\n  top: 50%;\n  left: 4px;\n  width: 9px;\n  height: 4px;\n  margin-top: -5px;\n  border-style: solid;\n  border-color: #008381;\n  border-width: 0 0 2px 2px;\n  border-image: none;\n  transform: rotate(-45deg) scale(0);\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:checked    + div[_ngcontent-%COMP%]:after {\n  content: '';\n  border-color: #fff;\n  transform: rotate(-45deg) scale(1);\n  transition: transform 200ms ease-out;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:checked    + div[_ngcontent-%COMP%]:before {\n  animation: borderscale 200ms ease-in;\n  background-color: #008381;\n  border-color: #008381;\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:checked    + div[_ngcontent-%COMP%]:after {\n  transform: rotate(-45deg) scale(1);\n}\n.multiselect-item-checkbox[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:checked    + #itemText[_ngcontent-%COMP%], .multiselect-item-checkbox.is-selected-item[_ngcontent-%COMP%]   #itemText[_ngcontent-%COMP%] {\n  color: #008381;\n  font-weight: 600;\n}\n@keyframes borderscale {\n  50% {\n    box-shadow: 0 0 0 2px #337ab7;\n  }\n}\n.li-disabled[_ngcontent-%COMP%] {\n  pointer-events: none;\n  opacity: 0.6;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DnaRDropdownMultiSelect, [{
        type: core_1.Component,
        args: [{
                selector: 'dnaR-dropdown-multiSelect',
                templateUrl: './dnaR-dropdown-multiSelect.component.html',
                styleUrls: ['./dnaR-dropdown-multiSelect.component.less'],
                providers: [exports.DROPDOWN_CONTROL_VALUE_ACCESSOR]
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { formControlName: [{
            type: core_1.Input
        }], error: [{
            type: core_1.Input
        }], placeholder: [{
            type: core_1.Input
        }], disabled: [{
            type: core_1.Input
        }], selectedItemsAsCommaSeparated: [{
            type: core_1.Input
        }], enableCheckAll: [{
            type: core_1.Input
        }], allowSearchFilter: [{
            type: core_1.Input
        }], showSelectedItemsAsTabs: [{
            type: core_1.Input
        }], searchPlaceholderText: [{
            type: core_1.Input
        }], noDataAvailablePlaceholderText: [{
            type: core_1.Input
        }], noSearchResultFoundPlaceholderText: [{
            type: core_1.Input
        }], settings: [{
            type: core_1.Input
        }], data: [{
            type: core_1.Input
        }], initialSelectedItems: [{
            type: core_1.Input
        }], initialSelectedItemsChange: [{
            type: core_1.Output
        }], onFilterChange: [{
            type: core_1.Output
        }], onDropDownClose: [{
            type: core_1.Output
        }], onSelect: [{
            type: core_1.Output
        }], onDeSelect: [{
            type: core_1.Output
        }], onSelectAll: [{
            type: core_1.Output
        }], onDeSelectAll: [{
            type: core_1.Output
        }], onTouchedEvent: [{
            type: core_1.Output
        }], onSelectionChange: [{
            type: core_1.Output
        }], onInitialised: [{
            type: core_1.Output
        }], onComponentChange: [{
            type: core_1.Output
        }], onTouched: [{
            type: core_1.HostListener,
            args: ['blur']
        }] }); })();
